import _ from 'lodash'

import {
  LIST_USER_CONTACTS_STARTED,
  LIST_USER_CONTACTS_COMPLETED,
  LIST_USER_CONTACTS_FAILED,

  ADD_USER_CONTACT_STARTED,
  ADD_USER_CONTACT_COMPLETED,
  ADD_USER_CONTACT_FAILED,

  DELETE_USER_CONTACT_STARTED,
  DELETE_USER_CONTACT_COMPLETED,
  DELETE_USER_CONTACT_FAILED,

  RESEND_VERIFICATION_USER_CONTACT_STARTED,
  RESEND_VERIFICATION_USER_CONTACT_COMPLETED,
  RESEND_VERIFICATION_USER_CONTACT_FAILED,

  UPDATE_PRIMARY_CONTACT_STARTED,
  UPDATE_PRIMARY_CONTACT_COMPLETED,
  UPDATE_PRIMARY_CONTACT_FAILED,

  CLEAR_STATES
} from '@/store/types'
import { marshalContact } from '@/utils/marshal'

function getDefaultState () {
  return {
    loading: false,
    done: false,
    error: undefined,
    resendDone: false,
    resendError: undefined,
    updatePrimaryDone: false,
    updatePrimaryError: undefined,

    actionLoading: false,
    actionError: undefined,

    contacts: []
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    // List contacts
    [LIST_USER_CONTACTS_STARTED] (state) {
      state.loading = true
    },
    [LIST_USER_CONTACTS_COMPLETED] (state, contacts = []) {
      state.contacts = _.cloneDeep(contacts.map(marshalContact))

      state.loading = false
      state.error = undefined
      state.done = true
    },
    [LIST_USER_CONTACTS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    [ADD_USER_CONTACT_STARTED] (state) {
      state.actionLoading = true
    },
    [ADD_USER_CONTACT_COMPLETED] (state) {
      state.done = true
      state.actionLoading = false
      state.actionError = undefined
    },
    [ADD_USER_CONTACT_FAILED] (state, err) {
      state.actionLoading = false
      state.actionError = err
    },

    [DELETE_USER_CONTACT_STARTED] (state) {
      state.actionLoading = true
    },
    [DELETE_USER_CONTACT_COMPLETED] (state, payload) {
      const { contactId } = payload
      state.contacts = state.contacts.filter(item => item.id !== contactId)
      state.actionError = undefined
      state.actionLoading = false
    },
    [DELETE_USER_CONTACT_FAILED] (state, err) {
      state.actionError = err
    },

    [RESEND_VERIFICATION_USER_CONTACT_STARTED] (state) {
      state.actionLoading = true
    },
    [RESEND_VERIFICATION_USER_CONTACT_COMPLETED] (state) {
      state.actionLoading = false
      state.resendDone = true
    },
    [RESEND_VERIFICATION_USER_CONTACT_FAILED] (state, err) {
      state.actionLoading = false
      state.resendError = err
    },
    [UPDATE_PRIMARY_CONTACT_STARTED] (state) {
      state.actionLoading = true
    },
    [UPDATE_PRIMARY_CONTACT_COMPLETED] (state) {
      state.actionLoading = false
      state.updatePrimaryDone = true
    },
    [UPDATE_PRIMARY_CONTACT_FAILED] (state, err) {
      state.actionLoading = false
      state.updatePrimaryError = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined, management } }, payload) {
      const { type } = payload
      try {
        commit(LIST_USER_CONTACTS_STARTED)
        const { id: userId } = management.userDetails.user
        const { contacts } = await client.managementClient.listContacts(userId, type)
        commit(LIST_USER_CONTACTS_COMPLETED, contacts)
      } catch (err) {
        commit(LIST_USER_CONTACTS_FAILED, err)
      }
    },
    async add ({ dispatch, commit, rootState: { client = undefined, management } }, payload) {
      const { type, contactValue } = payload
      try {
        commit(ADD_USER_CONTACT_STARTED)
        const { id: userId } = management.userDetails.user
        if (type === 'email') {
          await client.managementClient.createEmailContact(userId, contactValue)
        } else if (type === 'phone') {
          await client.managementClient.createPhoneContact(userId, contactValue)
        }
        await dispatch('list', {
          type: type
        })
        commit(ADD_USER_CONTACT_COMPLETED)
      } catch (err) {
        commit(ADD_USER_CONTACT_FAILED, err)
      }
    },
    async delete ({ commit, rootState: { client = undefined } }, contactId) {
      try {
        commit(DELETE_USER_CONTACT_STARTED)
        await client.managementClient.deleteContact(contactId)
        commit(DELETE_USER_CONTACT_COMPLETED, {
          contactId: contactId
        })
      } catch (err) {
        commit(DELETE_USER_CONTACT_FAILED, err)
      }
    },
    async resendContactVerification ({ commit, rootState: { client = undefined } }, contactId) {
      try {
        commit(RESEND_VERIFICATION_USER_CONTACT_STARTED)
        await client.managementClient.startVerifyContact(contactId)
        commit(RESEND_VERIFICATION_USER_CONTACT_COMPLETED)
      } catch (err) {
        commit(RESEND_VERIFICATION_USER_CONTACT_FAILED, err)
      }
    },
    async updatePrimaryContact ({ commit, dispatch, rootState: { client = undefined } }, payload) {
      const { contactId, type } = payload
      try {
        commit(UPDATE_PRIMARY_CONTACT_STARTED)
        await client.managementClient.updatePrimaryContact(contactId)
        await dispatch('list', { type })
        commit(UPDATE_PRIMARY_CONTACT_COMPLETED)
      } catch (err) {
        commit(UPDATE_PRIMARY_CONTACT_FAILED, err)
      }
    }
  }
}
